import { Grid, Paper, Stack } from "@mui/material";
import React from "react";
import CheckCodeForm from "../Components/CheckCodeForm";
import LoginForm from "../Components/LoginForm";
import { isMobile } from "react-device-detect";
import CreateUser from "../Components/CreateUser";
import { useContext } from "react";
import { ConfigLinksDetailsContext } from "../Context/cofingLinksDetailsContext";

const CheckCode = () => {
  const { configLinks } = useContext(ConfigLinksDetailsContext);
  const showRegForm = configLinks?.showRegistrationForm ?? true;

  return (
    <Paper sx={{ borderRadius: "27px" }} elevation={5}>
      <Grid container>
        <Grid
          sx={
            !isMobile
              ? {
                  boxShadow: "-10px 0px 10px 0px rgba(0, 0, 0, 0,8)",
                  ...(showRegForm ? {} : { margin: "0 auto" }),
                }
              : {}
          }
          item
          display="flex"
          justifyContent="center"
          xs={12}
          md={showRegForm ? 6 : 5}
        >
          <CheckCodeForm />
        </Grid>

        {showRegForm && (
          <Grid
            sx={
              isMobile
                ? { py: 4 }
                : {
                    backgroundColor: "#F4F8FC",
                    borderTopLeftRadius: "27px",
                    borderBottomRightRadius: "27px",
                  }
            }
            xs={12}
            item
            md={6}
          >
            <CreateUser />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};
export default CheckCode;
